import { AfterViewInit, Component, input } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Undo,
  type EditorConfig,
} from "ckeditor5";
import { CKEditorTags, Placeholder } from "./ckeditor-custom-tags";

@Component({
  standalone: true,
  selector: "app-publication-text-editor",
  templateUrl: "./publication-text-editor.component.html",
  styleUrl: "./publication-text-editor.component.scss",
  imports: [ReactiveFormsModule, CKEditorModule, TranslateModule],
})
export class PublicationTextEditorComponent implements AfterViewInit {
  protected readonly config: EditorConfig;
  protected readonly ClassicEditor = ClassicEditor;
  public readonly control = input.required<FormControl<string | null>>();
  protected readonly innerControl = new FormControl<string>("");

  constructor(translateService: TranslateService) {
    this.config = {
      toolbar: {
        items: ["undo", "redo"],
        shouldNotGroupWhenFull: false,
      },
      placeholderConfig: {
        types: Object.keys(CKEditorTags).map((tag) =>
          translateService.instant(tag),
        ),
      },
      plugins: [Essentials, Paragraph, Undo],
    } as EditorConfig;
  }

  public ngAfterViewInit(): void {
    this.config.plugins?.push(Placeholder);

    this.innerControl.valueChanges.subscribe((htmlContent) => {
      let filteredContent = htmlContent;
      if (htmlContent) {
        filteredContent = htmlContent
          .replace(/<p>/g, "")
          .replace(/<\/p>/g, "\n")
          .replace(/<br\s*\/?>/gi, "\n");
      }

      this.control().setValue(filteredContent);
      this.control().markAsTouched();
      this.control().markAsDirty();
    });
  }
}
